import React, { useEffect, useRef, useState } from 'react';
export default function PopupNumero({
  data,
  img,
  deactivate
}) {
  const [articles, setArticles] = useState(false);
  const dialog = useRef(null);
  useEffect(() => {
    const element = dialog.current;
    const previous = document.activeElement;
    element.showModal();
    return () => {
      element.close();
      previous?.focus();
    };
  }, []);
  const contents = [...(data.articulos || [])];

  if (data.dossier?.nameDossier) {
    const position = Number.isInteger(data.dossier.orden) ? Math.max(0, data.dossier.orden + 1) : contents.length;
    contents.splice(position, 0, {
      dossier: true
    });
  }

  return <dialog className="issue-dialog" ref={dialog} aria-labelledby="issue-dialog-title" onCancel={deactivate} onClick={event => {
    const bounds = event.currentTarget.getBoundingClientRect();
    if (event.target === event.currentTarget && (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom)) deactivate();
  }}>
        <button className="dialog-close" aria-label="Cerrar revista" onClick={deactivate}>×</button>
        <div className="dialog-layout"><img className="dialog-cover" src={img} alt={`Tapa de Boca de Sapo ${data.numero}`} /><div className="dialog-content"><span className="eyebrow">BOCA DE SAPO · N.º {data.numero}</span><h2 id="issue-dialog-title">{data.nombre || `Número ${data.numero}`}</h2><p>Una nueva conversación entre el arte, la literatura y el pensamiento.</p><div className="dialog-actions">{data.pdf && <a className="button button-dark" href={data.pdf} target="_blank" rel="noopener noreferrer">Leer PDF ↗</a>}{data.issu && <a className="button button-outline" href={data.issu} target="_blank" rel="noopener noreferrer">Leer en Issuu ↗</a>}</div><button className="articles-toggle text-link" onClick={() => setArticles(!articles)} aria-expanded={articles}>{articles ? 'Ocultar' : 'Ver'} artículos {articles ? '−' : '＋'}</button>
        {articles && <div className="issue-articles">{contents.map((entry, index) => entry.dossier ? <article key="dossier"><span className="eyebrow">DOSSIER</span><h3>{data.dossier.pdf ? <a href={data.dossier.pdf} target="_blank" rel="noopener noreferrer">{data.dossier.nameDossier} ↗</a> : data.dossier.nameDossier}</h3>{(data.dossier.autores || []).map((author, index) => <p key={index}>{author.pdf ? <a href={author.pdf} target="_blank" rel="noopener noreferrer">{author.name} ↗</a> : author.name} · {author.autor}</p>)}</article> : <article key={`${entry.name}-${index}`}><h3>{entry.pdf ? <a href={entry.pdf} target="_blank" rel="noopener noreferrer">{entry.name} ↗</a> : entry.name}</h3><p>{entry.autor}</p></article>)}</div>}</div></div>
    </dialog>;
}
